module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.forecastsAvailableXls.length > 1) ? _c('div', {
    staticClass: "selected d-flex justify-content-start align-items-center"
  }, [_vm._m(0), _vm._v(" "), [_c('ForecastMultiXlsIcon', {
    on: {
      "click": function($event) {
        _vm.downloadXls()
      }
    }
  })]], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("Selected :")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4efdc642","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ForecastMultiSelected.vue
// module id = 3175
// module chunks = 0